<template>
    <div class="flex flex-col items-center justify-center h-full">
        <div class="text-2xl font-bold">Oops! Something went wrong.</div>
        <div class="">Please try again later.</div>
    </div>
</template>
